import { useContext, useRef, useState } from "react";
import {
  FaCheckCircle,
  FaFileExcel,
  FaFilePdf,
  FaPrint,
  FaSearch,
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import useAxios from "../common/hook/useAxios";
import Dropdown from "./Dropdown";
import axios from "axios";
import {
  extractDate,
  formatDate,
  formatDateForInput,
  parseDateString,
  search,
} from "../constant";

const LabCenterComponent = ({
  firstData,
  toast,
  secondData,
  thirdData,
  setFromDate,
  setToDate,
  fromDate,
  toDate,
  handleData,
  isResult,
  setIsResult,
  setSelectedSearch,
  resetResultOnly,
  selectedDOS,
  filterType,
  handleFilterClick,
  setThirdData
}) => {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchOrder, setSearchOrder] = useState("");
  const [searchReq, setSearchReq] = useState("");
  const [selectedRows, setSelectedRows] = useState({});
  const [selectAll, setSelectAll] = useState(false);

  // console.log(isValidResult, selectedDOS);

  const checkResult = async () => {
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/RetrieveLabResults`;
    await axios
      .post(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Error while parsing", {
          autoClose: 3000,
        });
      });
  };

  const parse = async () => {
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/ReparseLabResults?sInputJSON={"ResultsArray":[{"RequisitionNumber":"C_h51-248180","LabID":7},{"RequisitionNumber":"C_h51-248162","LabID":7},{"RequisitionNumber":"C_h51-248081","LabID":7},{"RequisitionNumber":"SC_h51-247970","LabID":7},{"RequisitionNumber":"SC_h51-247969","LabID":7},{"RequisitionNumber":"SC_h51-247968","LabID":7},{"RequisitionNumber":"SC_h51-247967","LabID":7}]}`;
    await axios
      .post(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Error while parsing", {
          autoClose: 3000,
        });
      });
  };

  const handleSelectAll = () => {
    // If any patient is already selected, toggle the selection
    const shouldSelectAll =
      selectedRows && Object.values(selectedRows).some((value) => value);

    const newSelection = thirdData
      // .filter((item) => item.MissingDataDetails?.length == 0)
      .reduce((acc, row) => {
        acc[row.OrderNumber] = shouldSelectAll ? false : true; // If any selected, set all to false; otherwise, set all to true
        return acc;
      }, {});
    setSelectedRows(newSelection);
    setSelectAll(!shouldSelectAll);
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handlePrint = () => {
    if (tableRef.current) {
      const tableHTML = tableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`

        <html>
          <head>
            <title>Lab Reconcillation Print</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: left;
              }
              th {
                    background-color: #f4f4f4;
                    font-size:16px;
                  }
                    td{
                    font-size:14px}
                        @media print {
  .hide-on-print {
    display: none !important;
  }
}
            </style>
          </head>
          <body>
            ${tableHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table reference is not set.");
    }
  };

  const generateExcel = () => {
    if (tableRef.current) {
      const tableHtml = tableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" };
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/Excel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating excel", {
            autoClose: 3000,
          });
        });
    }
    // Add your logic for Excel export here
  };

  const generatePdf = () => {
    if (tableRef.current) {
      const tableHtml = tableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" }; //static
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/PDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating pdf", {
            autoClose: 3000,
          });
        });
    }
  };

  const filteredPatients =
    thirdData &&
    Array.isArray(thirdData) &&
    thirdData.filter((row) => {
      const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      const reqCaseMatches = row?.ExternalCaseNumber?.toLowerCase().includes(
        searchReq?.toLowerCase(),
      );
      const orderTypeMatches = row?.OrderTypeDesc?.trim()
        ?.toLowerCase()
        .includes(searchOrder?.trim()?.toLowerCase());
      // console.log(selectedDOS);

      const dosMatches =
        !selectedDOS ||
        new Date(row.DOS).toISOString().split("T")[0] ===
        new Date(selectedDOS).toISOString().split("T")[0];

      const resultFilePathExists =
        row.resultRecievedDate !== null &&
        row.resultRecievedDate !== "" &&
        row.resultRecievedDate !== undefined;

      let typeMatches = true;
      if (filterType === "sent") {
        typeMatches = dosMatches;
      } else if (filterType === "received") {
        typeMatches = dosMatches && resultFilePathExists;
      } else if (filterType === "notReceived") {
        typeMatches = dosMatches && !resultFilePathExists;
      }

      return (
        fullName.includes(searchTermNormalized) &&
        reqCaseMatches &&
        orderTypeMatches &&
        typeMatches
      );
    });

  const handleSearch = () => {
    if (!fromDate) {
      setError("Please select Start Date");
      return;
    }
    if (!toDate) {
      setError("Please select To Date");
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      setError("From date must be before To date.");
      return;
    }
    setError("");
    handleData();
  };

  const fields = [
    "buckSent",
    "buckRecvd",
    "buckDiff",
    "toxSent",
    "toxRecvd",
    "toxDiff",
    "toxSent",
    "paraPRESent",
    "paraPRERecvd",
    "paraPREDiff",
    "bloodSent",
    "bloodRecvd",
    "bloodDiff",
    "STIDiff",
    "STIRecvd",
    "STISent",
    "paraCNFSent",
    "paraCNFRecvd",
    "paraCNFDiff",
  ];
  const calculateTotal = (rows, field) => {
    return rows?.reduce((acc, row) => acc + (row[field] || 0), 0);
  };

  const totals = fields?.reduce((acc, field) => {
    acc[field] = calculateTotal(firstData, field);
    return acc;
  }, {});

  const filterRecords = (filterKey, FromDate, ToDate) => {
    // console.log(filterKey, FromDate, ToDate);

    const fromDate = extractDate(FromDate)
    const toDate = extractDate(ToDate)
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabReconcillation/GetLabReconciliationData?sInputJSON={"PracticeId":"${user?.PracticeID}","FromDate":"${fromDate}","ToDate":"${toDate}", "SearchBy":"${filterKey}","IsResultOnly":false}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setThirdData(res);
      })
      .catch(() => {
        toast.error("Error occurred while filtering", {
          autoClose: 3000,
        });
      });
  };

  return (
    <div>
      <header className="bg-blue-200 text-black p-4 flex items-center w-full">
        <div className="flex items-center space-x-4">
          <Dropdown
            items={search}
            label={"Search By:"}
            setSelectedValue={setSelectedSearch}
            isHeader={true}
          />
          <label
            htmlFor="from-date"
            className="block text-md font-medium text-white-300"
          >
            From:
          </label>
          <input
            type="date"
            id="from-date"
            value={formatDateForInput(fromDate)}
            onChange={(e) => {
              const dateString = e.target.value;
              const newDate = parseDateString(dateString);
              if (newDate) {
                setFromDate(newDate); // Update the state with Date object
                setError(""); // Clear any previous errors
              } else {
                setError("Invalid date format.");
              }
            }}
            className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
          {/* </div> */}
          {/* <div> */}
          <label
            htmlFor="to-date"
            className="block text-md font-medium text-white-300"
          >
            To:
          </label>
          <input
            type="date"
            id="to-date"
            value={formatDateForInput(toDate)}
            onChange={(e) => {
              const dateString = e.target.value;
              const newDate = parseDateString(dateString);
              if (newDate) {
                setToDate(newDate); // Update the state with Date object
                setError(""); // Clear any previous errors
              } else {
                setError("Invalid date format.");
              }
            }}
            className="mt-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
          <input
            type="checkbox"
            checked={isResult}
            onChange={(e) => {
              setIsResult(e.target.checked);
            }}
          />
          <label>Results only</label>
          {/* </div> */}
          <button
            onClick={handleSearch}
            className="flex items-center bg-orange text-white py-2 px-4 rounded-md shadow-sm focus:outline-none"
          >
            <FaSearch className="mr-2" />
            Search
          </button>
          <button className="underline" onClick={resetResultOnly}>
            Show All
          </button>
        </div>
      </header>
      <div className="overflow-auto max-h-[50vh]">
        <table className="min-w-full overflow-auto bg-white border border-gray-300">
          <tbody>
            <tr class="gvheader" className="bg-[#005d97] border-b border-black text-white">
              <th
                scope="col"
                style={{ whiteSpace: "nowrap" }}
                className="p-2 border-r border-black"
              >
                #
              </th>
              <th
                scope="col"
                style={{ whiteSpace: "nowrap" }}
                className="p-2 border-r border-black"
              >
                DOS
              </th>
              <th
                scope="col"
                // style={{ whiteSpace: "nowrap" }}
                className="p-2 border-r border-black"
              >
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        Presumptive Positive (buckeye Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th scope="col" className="p-2 border-r border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        Confirmation (Buckeye confirmatory Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th scope="col" className="p-2 border-r border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        Presumptive Positive (Paracelsus Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th scope="col" className="p-2 border-r border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        Confirmation (Paracelsus Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th scope="col" className="p-2 border-r border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        Blood (Path Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th scope="col" className="p-2 border-r border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td colspan="3" align="center">
                        STI (Access Lab)
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">Sent</td>
                      <td width="30%">
                        <span className="text-green-300">Received</span>
                      </td>
                      <td>
                        <span className="text-red-300 leading-none">
                          Not Received
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </th>
            </tr>

            {firstData &&
              Array.isArray(firstData) &&
              firstData?.map((row, index) => {
                return (
                  <tr key={index + 1} data-tooltip-place="top">
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r  border-b border-black"
                    >
                      {formatDate(new Date(row.DOS))}
                    </td>
                    <td className="p-2 border-r  border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("buckSent", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.buckSent}
                              </button>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("buckRecvd", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.buckRecvd}
                              </button>
                            </td>
                            <td>
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("buckDiff", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.buckDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <td className="p-2 border-r  border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("toxSent", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.toxSent}
                              </button>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("toxRecvd", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.toxRecvd}
                              </button>
                            </td>
                            <td>
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("toxDiff", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.toxDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td className="p-2 border-r  border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraPRESent", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.paraPRESent}
                              </button>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraPRERecvd", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.paraPRERecvd}
                              </button>
                            </td>
                            <td>
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraPREDiff", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.paraPREDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td className="p-2 border-r  border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <a
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraCNFSent", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.paraCNFSent}
                              </a>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraCNFRecvd", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.paraCNFRecvd}
                              </button>
                            </td>
                            <td>
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("paraCNFDiff", row?.DOS, row?.DOS)
                                }
                              // style="color:Red;"
                              >
                                {row?.paraCNFDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td className="p-2 border-r border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("bloodSent", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.bloodSent}
                              </button>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("bloodRecvd", row?.DOS, row?.DOS)
                                }
                              // style="color:Green;"
                              >
                                {row?.bloodRecvd}
                              </button>
                            </td>
                            <td>
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("bloodDiff", row?.DOS, row?.DOS)
                                }
                              // style="color:Red;"
                              >
                                {row?.bloodDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td className="p-2 border-r border-b border-black">
                      <table width="100%" cellpadding="3" cellspacing="1">
                        <tbody>
                          <tr>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("STISent", row?.DOS, row?.DOS)
                                }
                              >

                                {row?.STISent}
                              </button>
                            </td>
                            <td width="30%">
                              <button
                                className="underline"
                                onClick={() =>
                                  filterRecords("STIRecvd", row?.DOS, row?.DOS)
                                }
                              >
                                {row?.STIRecvd}
                              </button>
                            </td>
                            <td>
                              <button className="underline"
                                onClick={() =>
                                  filterRecords("row?.STIDiff", row?.DOS, row?.DOS)
                                }

                              >
                                {row?.STIDiff}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                );
              })}
            <tr className="bg-gray-200">
              <td className="p-2 border-r border-b border-black">Total</td>
              <td className="p-2 border-r border-b border-black"> </td>
              <td className="p-2 border-r border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("buckSent", fromDate, toDate)
                        }>{totals.buckSent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("buckRecvd", fromDate, toDate)
                        }>{totals.buckRecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("buckDiff", fromDate, toDate)
                        }>{totals.buckDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>



              <td className="p-2 border-r border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("toxSent", fromDate, toDate)
                        }>{totals.toxSent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("toxRecvd", fromDate, toDate)
                        }>{totals.toxRecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("toxDiff", fromDate, toDate)
                        }>{totals.toxDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td className="p-2 border-r border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraPRESent", fromDate, toDate)
                        }>{totals.paraPRESent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraPRERecvd", fromDate, toDate)
                        }>{totals.paraPRERecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraPREDiff", fromDate, toDate)
                        }>{totals.paraPREDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td className="p-2 border-r border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraCNFSent", fromDate, toDate)
                        }>{totals.paraCNFSent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraCNFRecvd", fromDate, toDate)
                        }>{totals.paraCNFRecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("paraCNFDiff", fromDate, toDate)
                        }>{totals.paraCNFDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td className="p-2 border-r border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("bloodSent", fromDate, toDate)
                        }>{totals.bloodSent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("bloodRecvd", fromDate, toDate)
                        }>{totals.bloodRecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("bloodDiff", fromDate, toDate)
                        }>{totals.bloodDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td className="p-2 border-r  border-b border-black">
                <table width="100%" cellpadding="3" cellspacing="1">
                  <tbody>
                    <tr>
                      <td width="30%">
                        <p className="text-blue-400 underline cursor-pointer" onClick={() =>
                          filterRecords("STISent", fromDate, toDate)
                        }>{totals.STISent}</p>
                      </td>
                      <td width="30%">
                        <p className="text-green-400 underline cursor-pointer" onClick={() =>
                          filterRecords("STIRecvd", fromDate, toDate)
                        }>{totals.STIRecvd}</p>
                      </td>
                      <td>
                        <p className="text-red-400 underline cursor-pointer" onClick={() =>
                          filterRecords("STIDiff", fromDate, toDate)
                        }>{totals.STIDiff}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-[#005d97] border-b border-black text-white">
            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
              #
            </th>
            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
              Received Date
            </th>
            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
              Recieved File
            </th>
            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
              Processed Files
            </th>
            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
              Unprocessed Files
            </th>
          </tr>
        </thead>{" "}
        <tbody>
          {secondData && Array.isArray(secondData) ? (
            secondData?.map((row, index) => (
              <tr key={index + 1} data-tooltip-place="top">
                <td
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-b border-black"
                >
                  {index + 1}
                </td>
                <td
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-b border-black"
                >
                  {row?.ReceivedDate}
                </td>
                <td
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-b border-black"
                >
                  {row?.ReceivedFies}
                </td>
                <td
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-b border-black"
                >
                  {row?.ProcessedFiles}
                </td>
                <td
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-b border-black"
                >
                  {row?.UnprocessedFiles}
                </td>
              </tr>
            ))
          ) : (
            <p>No records found!!!</p>
          )}
        </tbody>
      </table>
      <div className="text-right text-white my-2">
        <button className="bg-orange p-2 rounded-lg" onClick={checkResult}>
          Check Results
        </button>
        <button className="bg-orange p-2 ml-2 rounded-lg" onClick={parse}>
          Reparse
        </button>
      </div>
      <div ref={tableRef} className="overflow-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-[#005d97] border-b border-black text-white">
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                #
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                DOS
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Patient Name <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print"
                  placeholder="Search by Patient Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                DOB
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Provider
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                POC
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Order Type <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print"
                  placeholder="Search Order Type"
                  value={searchOrder}
                  onChange={(e) => setSearchOrder(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Req/Case # <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print"
                  placeholder="Search"
                  value={searchReq}
                  onChange={(e) => setSearchReq(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Screening
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Confirmation
              </th>
              <th
                style={{ whiteSpace: "nowrap" }}
                className="p-2 border-r border-black flex flex-col gap-1"
              >
                <div className="flex flex-row gap-1 mt-3">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectAll}
                  />
                  <FaPrint
                    className="cursor-pointer text-blue-800"
                    onClick={handlePrint}
                  />
                </div>
                <div className="flex flex-row gap-1">
                  <FaFilePdf
                    onClick={generatePdf}
                    className="cursor-pointer text-red-400"
                  />
                  <FaFileExcel
                    onClick={generateExcel}
                    className="cursor-pointer text-emerald-500"
                  />
                </div>
              </th>
            </tr>
          </thead>{" "}
          <tbody>
            {thirdData && Array.isArray(thirdData) && thirdData?.length > 0 ? (
              (searchTerm?.trim() !== "" ||
                searchOrder?.trim() !== "" ||
                searchReq?.trim() !== ""
                // ||
                // selectedDOS !== null ||
                // filterType !== null
                ? filteredPatients
                : thirdData
              )?.map((row, index) => {
                // console.log(row);

                return (
                  <tr key={row.id} data-tooltip-place="top">
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {formatDate(new Date(row.DOS))}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black cursor-pointer text-blue-700 underline"
                      onClick={() => {
                        const url = `/patient-dashboard?patientId=${row?.PatientID}&patientName=${encodeURIComponent(row?.FirstName + row?.LastName)}`;
                        window.open(url, "_blank");
                      }}
                    >
                      {`${row?.LastName || ""}, ${row?.FirstName || ""}`}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.DOB}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.ProviderName}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.POCResults}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.OrderTypeDesc}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.ExternalCaseNumber}
                      {row?.LabCpt && (
                        <FaCheckCircle className="cursor-pointer text-green-500" />
                      )}
                      <FaFilePdf
                        onClick={() => window.open(row?.ReqPDFURL, "_blank")}
                        className="cursor-pointer text-red-400"
                      />
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.LabResults}
                      {row?.IsScreeningResReceived && (
                        <FaCheckCircle className="cursor-pointer text-green-500" />
                      )}
                      {row.labDocPDFPath != null && row.labDocPDFPath != "" && (
                        <FaFilePdf
                          onClick={() =>
                            window.open(row?.labDocPDFPath, "_blank")
                          }
                          className="cursor-pointer text-red-400"
                        />
                      )}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      {row?.LabResults}
                      {row?.IsConfirmationResReceived && (
                        <FaCheckCircle className="cursor-pointer text-green-500" />
                      )}
                      {row.confirmlabDocPDFPath != null &&
                        row.confirmlabDocPDFPath != "" && (
                          <FaFilePdf
                            onClick={() =>
                              window.open(row?.confirmlabDocPDFPath, "_blank")
                            }
                            className="cursor-pointer text-red-400"
                          />
                        )}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black"
                    >
                      <input
                        // disabled={row.MissingDataDetails?.length > 0}
                        type="checkbox"
                        checked={!!selectedRows[row.OrderNumber]}
                        onChange={() => handleRowSelect(row.OrderNumber)}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={10} className="p-2 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LabCenterComponent;
